import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Refresh = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M5 4.438v3.25c0 .414.336.75.75.75h3m10.262 12v-3.25a.75.75 0 0 0-.75-.75h-3.25M4 12.438a8 8 0 0 0 8 8 8.14 8.14 0 0 0 6.5-3.242m1.5-4.758a8 8 0 0 0-8-8A8.14 8.14 0 0 0 5.5 7.68'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5 3.688a.75.75 0 0 1 .75.75v1.817A8.9 8.9 0 0 1 12 3.688a8.75 8.75 0 0 1 8.75 8.75.75.75 0 0 1-1.5 0A7.25 7.25 0 0 0 12 5.188c-2.19 0-4.196.97-5.541 2.5H8.75a.75.75 0 1 1 0 1.5h-3a1.5 1.5 0 0 1-1.5-1.5v-3.25a.75.75 0 0 1 .75-.75m-1 8a.75.75 0 0 1 .75.75 7.25 7.25 0 0 0 7.25 7.25c2.19 0 4.196-.97 5.541-2.5h-2.53a.75.75 0 0 1 0-1.5h3.25a1.5 1.5 0 0 1 1.5 1.5v3.25a.75.75 0 1 1-1.5 0V18.61A8.9 8.9 0 0 1 12 21.188a8.75 8.75 0 0 1-8.75-8.75.75.75 0 0 1 .75-.75'
        fill='currentColor'
      />
    )}
  </IconBase>
);
